import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { get, pick } from 'lodash';
import type { UpdateLocationMutation, Location } from '#/graphql/types';
import { updateLocation } from '#/graphql/mutations';
import { updateMutationFields } from '../utils/mutationDataFields';
import { GET_LOCATION } from './useLocationQuery';

const q = gql(updateLocation);

const useLocationUpdate = () => {
  const [mutation, result] = useMutation<UpdateLocationMutation>(q);
  const updateLocation = useCallback(
    async (itemId: string, location: Location) => {
      const response = await mutation({
        variables: {
          id: itemId,
          data: pick(location, updateMutationFields),
        },
        refetchQueries: [{ query: GET_LOCATION, variables: { id: itemId } }],
        awaitRefetchQueries: true,
      });

      return get(response, 'data.updateLocation', undefined);
    },
    [mutation],
  );

  return { updateLocation, result };
};

export default useLocationUpdate;
